import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtTRY, isKurumsal } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Search, Plus, Users } from "lucide-react";

const filters = [
  { key: "hepsi", label: "Hepsi" },
  { key: "bireysel", label: "Bireysel" },
  { key: "kurumsal", label: "Kurumsal" },
];

export default function Customers() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [tur, setTur] = useState("hepsi");
  const navigate = useNavigate();

  const load = () => {
    api.get("/customers", { params: { search: search || undefined, tur } }).then((r) => setRows(r.data));
  };

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [search, tur]);

  return (
    <div className="p-8 max-w-[1400px]">
      <div className="flex items-start justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Müşteriler</h1>
          <p className="text-zinc-500 text-sm mt-1">{rows.length} kayıt listeleniyor</p>
        </div>
        <Button data-testid="new-customer-btn" onClick={() => navigate("/musteriler/yeni")} className="rounded-none bg-white text-black hover:bg-zinc-200 font-semibold">
          <Plus className="w-4 h-4 mr-1.5" /> Yeni Müşteri
        </Button>
      </div>

      <div className="flex items-center gap-3 mb-4">
        <div className="relative flex-1 max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <Input
            data-testid="customer-search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Unvan, kod veya telefon ara..."
            className="pl-9 rounded-none bg-zinc-950 border-zinc-800 focus-visible:ring-white"
          />
        </div>
        <div className="flex border border-zinc-800">
          {filters.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${f.key}`}
              onClick={() => setTur(f.key)}
              className={`px-4 py-2 text-sm font-medium transition-colors ${tur === f.key ? "bg-white text-black" : "text-zinc-400 hover:text-white bg-zinc-950"}`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <div className="border border-zinc-800 bg-zinc-950">
        <Table>
          <TableHeader>
            <TableRow className="border-zinc-800 hover:bg-transparent">
              <TableHead className="text-zinc-400 uppercase text-[11px] tracking-widest">Müşteri</TableHead>
              <TableHead className="text-zinc-400 uppercase text-[11px] tracking-widest">Tip</TableHead>
              <TableHead className="text-zinc-400 uppercase text-[11px] tracking-widest">Telefon</TableHead>
              <TableHead className="text-zinc-400 uppercase text-[11px] tracking-widest text-right">Bakiye</TableHead>
              <TableHead className="text-zinc-400 uppercase text-[11px] tracking-widest">Kabul</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 && (
              <TableRow className="border-zinc-800 hover:bg-transparent">
                <TableCell colSpan={5} className="text-center py-16">
                  <Users className="w-8 h-8 text-zinc-700 mx-auto mb-3" />
                  <p className="text-zinc-500 text-sm">Kayıt bulunamadı. Yeni müşteri ekleyin.</p>
                </TableCell>
              </TableRow>
            )}
            {rows.map((r) => (
              <TableRow
                key={r.id}
                data-testid={`customer-row-${r.id}`}
                onClick={() => navigate(`/musteriler/${r.id}`)}
                className="border-zinc-900 cursor-pointer hover:bg-zinc-900"
              >
                <TableCell className="py-3">
                  <div className="font-medium">{r.unvan || "İsimsiz"}</div>
                  {r.musteri_kodu && <div className="text-xs text-zinc-500 font-mono">{r.musteri_kodu}</div>}
                </TableCell>
                <TableCell>
                  <Badge variant="outline" className="rounded-none text-[10px] uppercase tracking-wider border-zinc-700 text-zinc-300">
                    {r.tur ? (isKurumsal(r.tur) ? "Kurumsal" : "Bireysel") : "-"}
                  </Badge>
                </TableCell>
                <TableCell className="font-mono text-sm text-zinc-300">{r.cep_telefonu || "-"}</TableCell>
                <TableCell className="text-right font-mono text-sm">
                  <span className={r.bakiye > 0 ? "text-yellow-400" : r.bakiye < 0 ? "text-green-400" : "text-zinc-400"}>
                    {fmtTRY(r.bakiye)}
                  </span>
                </TableCell>
                <TableCell>
                  <span className="text-xs text-zinc-400">{r.kabul_sonucu || "-"}</span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
